import { Component, h, Prop } from '@stencil/core';
import { getIconFromName } from './iconUtils';

@Component({
  tag: 'udp-icon',
  styleUrl: 'udp-icon.css',
  shadow: true,
})
export class UdpIcon {
  @Prop() iconName: string;
  @Prop() iconType: string = 'carbon';
  @Prop() darkIcon: boolean = true;

  render() {
    const iconData = getIconFromName(this.iconName, this.iconType);
    const iconColor = this.darkIcon ? 'black' : 'white';

    return (
      <div class="icon-container">
        <svg {...(iconData?.attrs ?? {})} fill={iconColor}>
          {iconData?.content?.map((item, index) => {
            if (item?.elem === 'path') {
              return <path {...(item?.attrs ?? {})} key={index} />;
            } else if (item?.elem === 'circle') {
              return <circle {...(item?.attrs ?? {})} key={index} />;
            }
            return null;
          })}
        </svg>
      </div>
    );
  }
}
